'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { setBodyOverflowHidden } from '@/app/_utils/set-body-overflow';
import { cn } from '@/utils/cn';
import { useDrawer } from './context/use-drawer';
interface Props {
  position: 'left' | 'right' | 'top' | 'bottom';
  children: React.ReactNode;
  name: string;
  className?: string;
  withBackDrop?: boolean;
  isMenuDrawer?: boolean;
}
const Drawer = ({
  position,
  children,
  name,
  className,
  withBackDrop,
  isMenuDrawer
}: Props) => {
  const pathName = usePathname();
  const {
    isDrawerOpen,
    closeDrawer,
    closeAllDrawers
  } = useDrawer();
  const isOpen = isDrawerOpen(name);
  useEffect(() => {
    setBodyOverflowHidden(isOpen);
  }, [isOpen]);
  useEffect(() => {
    closeAllDrawers();
    setBodyOverflowHidden(false);
  }, [closeAllDrawers, pathName]);
  return <div data-test='drawer' className={cn('invisible fixed left-0 top-0 -z-10 h-full w-screen opacity-0 transition-all ease-in-out lg:hidden', {
    'visible z-top-of-chatbot-plus1 opacity-100': isOpen
  }, {
    'duration-300 [&>*]:translate-y-full': position === 'bottom'
  }, {
    'duration-300 [&>*]:-translate-y-full': position === 'top'
  }, {
    '[&>*]:translate-y-0': (position === 'bottom' || position === 'top') && isOpen
  }, {
    'duration-0 [&>div]:translate-x-full': position === 'right'
  }, {
    '[&>div]:w-5/6 [&>div]:translate-x-0 [&>div]:lg:w-3/4': position === 'right' && isOpen
  }, {
    'duration-0 [&>div]:-translate-x-full': position === 'left'
  }, {
    '[&>div]:mr-auto [&>div]:w-5/6 [&>div]:translate-x-0 [&>div]:lg:w-3/4': position === 'left' && isOpen
  }, {
    '[&>div]:w-full [&>div]:translate-x-0 [&>div]:lg:w-3/4': isMenuDrawer && isOpen
  })} data-sentry-component="Drawer" data-sentry-source-file="index.tsx">
            <label className={cn('absolute top-0 -z-10 h-screen w-full bg-black bg-opacity-60', {
      hidden: !withBackDrop
    })} onClick={() => closeDrawer(name)}></label>
            <div className={cn('relative flex h-full flex-col overflow-x-hidden bg-white transition-all duration-300 ease-in-out', name, className)}>
                {children}
            </div>
        </div>;
};
export default Drawer;